module.exports = __webpack_public_path__ + "media/honey-icons/icon-plug-in-4ff89dd2.svg";